import { CopyAll, Delete, Inventory } from '@mui/icons-material'
import { styled } from '@mui/material/styles'
import { Skeleton, Typography } from '@mui/material'
import { Box, Chip, IconButton, Tooltip } from 'components'
import { formatCurrency } from 'utils'
import { memo, useState } from 'react'
import { NO_IMAGE, quantityIds } from 'config'
import { useOrderStore } from 'modules/orders/store'
import { useItemFormDrawerStore } from '../ItemForm/itemFormDrawerStore'
import { HiPencil } from 'react-icons/hi'
import { useItemConfigurationReplicateDrawerStore } from 'modules/orders/components/Form/items/ItemConfiguration'
import { RawMaterialsModal } from '../ItemForm/RawMaterialsModal'
// import { useCreateIdentifier } from '../ItemConfiguration/services/useCreateIdentifier'

const ItemContent = styled('div')(() => ({
  // '&:hover': {
  //   backgroundColor: 'rgba(0, 111, 178, 0.3)'
  // }
}))

export const Item = memo(function Item({ item, style }: any) {
  const [isRawMaterialsModalOpen, setIsRawMaterialsModalOpen] = useState(false)
  const removeFormItem = useOrderStore.useRemoveFormItem()
  // const addProductForm = useOrderStore.useAddProductForm()
  const setIsDrawerOpen = useItemFormDrawerStore.useSetIsDrawerOpen()
  const setIsReplicateDrawerOpen =
    useItemConfigurationReplicateDrawerStore.useSetIsDrawerOpen()
  const setItemConfigurationReplicateProduct =
    useItemConfigurationReplicateDrawerStore.useSetProduct()

  const setSelectedItem = useItemFormDrawerStore.useSetSelectedItem()
  const setItemMode = useItemFormDrawerStore.useSetItemMode()
  const setProductId = useItemFormDrawerStore.useSetProductId()

  // const { data: identifier } = useCreateIdentifier(
  //   item?.configurationFormValues || {}
  // )

  const especif1 = item.configurationId || ''

  // const {
  //   data: productPrice,
  //   isLoading: productPriceLoading,
  //   isFetching: productPriceFetching
  // } = useLoadOrderProductPrice({
  //   orderId: form?.orderId || '',
  //   sequence: item.sequence || sequence[item.uuid],
  //   customerId: watch('customer')?.id,
  //   paymentTermId: watch('paymentTerm')?.id,
  //   // sellerId: watch('seller')?.id,
  //   sellerId: watch('seller2')?.id,
  //   productId: item.product.id,
  //   configurationId: item?.configurationId || '',
  //   quantity: Number(item.quantity),
  //   origin: Number(item.origin),
  //   unityId: watch('unity')?.id
  // })

  // const isLoading = productPriceLoading || productPriceFetching
  const isLoading = false

  // useEffect(() => {
  //   if (productPrice)
  //     addProductForm({
  //       ...productPrice.data,
  //       ...item,
  //       defaultPrice: productPrice?.data?.defaultPrice,
  //       sequence: item.sequence || sequence[item.uuid]
  //     })
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [productPrice, addProductForm])

  const particularFields = Object.keys(item?.configurationFormValues || {})

  // console.log(item)

  // console.log(item?.product?.imageUrl)
  const hasLengthField = particularFields.some((pf) => quantityIds.includes(pf))
  return (
    <>
      <RawMaterialsModal
        productId={item?.product?.id || ''}
        especif1={especif1}
        quantity={item?.quantity || 1}
        open={isRawMaterialsModalOpen && !!especif1}
        onClose={() => setIsRawMaterialsModalOpen(false)}
      />
      <Box
        style={{
          display: 'flex',
          // borderLeft: `6px solid ${getBorderColor(item?.margin?.percent)}`,
          ...style
        }}
      >
        <img
          height={110}
          width={110}
          loading="lazy"
          src={item?.imageUrl || NO_IMAGE}
          style={{ objectFit: 'contain', backgroundColor: 'white' }}
        />

        <ItemContent
          style={{
            flex: 1
          }}
          // onClick={() => {
          //   setIsDrawerOpen(true)
          //   setProductId(item.product.id)
          //   setSelectedItem(item)
          // }}
        >
          <Box
            style={{
              padding: 8,
              display: 'flex',
              flex: '1',
              flexDirection: 'column'
            }}
          >
            <Box
              style={{
                width: '100%',
                flex: 1,
                justifyContent: 'space-between'
              }}
            >
              <Box
                style={{
                  display: 'flex',
                  flex: '1',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <Box
                  style={{
                    flex: 1,
                    width: 600,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: 'box'
                  }}
                >
                  <Tooltip
                    maxWidth={600}
                    placement="bottom-start"
                    title={`${item.product.id} | ${item.sequence} | ${item.configurationId} - ${item.configurationDescription}`}
                  >
                    <Typography variant="caption" noWrap>
                      {item.product.id} | {item.sequence} |{' '}
                      {item.configurationId} - {item.configurationDescription}
                    </Typography>
                  </Tooltip>
                </Box>

                <Box>
                  <IconButton
                    size="small"
                    onClick={(event: any) => {
                      event?.stopPropagation?.()
                      removeFormItem(item.uuid)
                    }}
                  >
                    <Delete color="error" fontSize="small" />
                  </IconButton>
                </Box>
              </Box>

              <Typography
                textOverflow={'ellipsis'}
                style={{
                  fontWeight: 700,
                  fontSize: 14
                }}
              >
                {item?.product?.name}
              </Typography>
            </Box>
            <Box
              style={{
                width: '100%',
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography variant="caption">
                {isLoading && (
                  <Skeleton width={80} animation="wave" height={20} />
                )}
                {formatCurrency(item?.currentPrice || item?.defaultPrice)} |{' '}
                {!isLoading &&
                  formatCurrency(
                    (item?.currentPrice || item?.defaultPrice) *
                      Number(item?.quantity)
                  )}
              </Typography>

              <Typography
                style={{
                  fontWeight: 500,
                  width: '20%',
                  fontSize: 14
                }}
              >
                {item?.quantityUn} UN ({item?.quantity}{' '}
                {item?.product?.unitMeasure.trim() || ' S/U.M'})
              </Typography>

              <Typography
                style={{
                  width: '50%',
                  fontSize: 12
                }}
              >
                {item?.priceTable?.name}
              </Typography>
            </Box>

            <Box
              style={{
                width: '100%',
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography
                style={{
                  width: '30%',
                  fontWeight: 700,
                  fontSize: 14,
                  color: '#389e0d'
                }}
              >
                {formatCurrency(item?.salePrice)} |{' '}
                {formatCurrency(item?.salePrice * Number(item?.quantity))}
              </Typography>

              <Box
                style={{
                  width: '100%',
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end'
                }}
              >
                <Box
                  style={{
                    marginRight: 8
                  }}
                >
                  <Chip
                    label="repetir configuração"
                    onClick={() => {
                      setIsReplicateDrawerOpen(true)
                      // console.log(item)
                      setItemConfigurationReplicateProduct(item)
                    }}
                    disabled={isLoading || !hasLengthField}
                    icon={<CopyAll />}
                  />
                </Box>

                {item?.configurationId && !item?.isMaterial && (
                  <Box
                    style={{
                      marginRight: 8
                    }}
                  >
                    <Chip
                      label="matérias primas"
                      onClick={() => {
                        setIsRawMaterialsModalOpen(true)
                      }}
                      disabled={isLoading}
                      icon={<Inventory />}
                    />
                  </Box>
                )}

                <Chip
                  label="editar"
                  onClick={() => {
                    setIsDrawerOpen(true)
                    setProductId(item.product.id)
                    setSelectedItem(item)
                    setItemMode('edit')
                  }}
                  disabled={isLoading}
                  icon={<HiPencil />}
                />
              </Box>
            </Box>
          </Box>
        </ItemContent>
      </Box>
    </>
  )
})
